import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { animations } from "helpers/animations";

import makeAnimated from "react-select/animated";
//Mui
import {
  FormControl,
  FormLabel,
  Grid,
  TextField,
  InputAdornment,
} from "@mui/material";
import CancelIcon from "@mui/icons-material/Cancel";

import { useForm } from "hooks/useForm";
import { useScrollTop } from "hooks/useScrollTop";

//Component
import { SelectComponent } from "components/SelectMenu/SelectComponent";

import RegularButton from "components/CustomButtons/Button";
import Snackbar from "components/Snackbar/Snackbar";
import { MultiSelect } from "components/MultiSelect/MultiSelect";

//Redux
import {
  resetItemSnackbar,
  setItemSnackbar,
  itemsRequests,
  saveItemsToUpdate,
  removeItemToUpdate,
  saveOriginalItemToUpdate
} from "redux/actions/integrations/itemsActions";
import { NewItemForm } from "./NewItemForm";


//Clean values
const initialValues = {
  itemId: "",
  itemNumber: "",
  description: "",
  application: "",
  brand: "",
  price: "",
  partNumber: "",
  uom: "",
  idStations: [],
  inventoriable: "1",
  idCategory: '',
  idClass: '',
};

const animatedComponents = makeAnimated();

export const ItemForm = (props) => {
  const { onClose } = props;
  const dispatch = useDispatch();
  const {
    item,
    modalEdit,
    newItemMode,
    idStation,
    updateItems,
    snackbar,
    originalItems
  } = useSelector(({ items }) => items);
  const { id: idUser } = useSelector(({ login }) => login);
  const { color, message, isOpen } = snackbar;
  const { stationsList } = useSelector(({ companiesItems }) => companiesItems);
  const { categories } = useSelector(({ categories }) => categories);
  const { classes: allClasses } = useSelector(({ classes }) => classes);
  const [stationsValues, setStationValues] = useState(stationsList.map(station => {
    return item?.organizations && Object.keys(item?.organizations).find(key => key === station?.id) ?
      { value: station.id, label: `${station.name} ($ ${item?.organizations[station.id]?.listPrice})`, oraclePrice: item?.organizations[station.id]?.listPrice } :
      { value: station.id, label: station.name };
  }))
  const ref = useScrollTop()
  const fieldValidations = {
    itemId: {
      required: !newItemMode
    },
    itemNumber: {
      required: !newItemMode
    },
    description: {
      required: newItemMode,
    },
    application: {
      required: newItemMode
    },
    brand: {
      required: newItemMode,
    },
    price: {
      required: true,
    },
    uom: {
      required: newItemMode
    },
    idStations: {
      required: true,
    },
    idCategory: {
      required: newItemMode,
    },
    idClass: {
      required: newItemMode,
    },
    inventoriable: {
      required: newItemMode,
    }
  };
  const {
    inputValues,
    handleInputOnChange,
    cleanForm,
    handleNewValues,
    fieldErrors,
    runValidates,
  } = useForm(initialValues, fieldValidations);

  const [selectedCompanies, setSelectedCompanies] = useState([]);
  const [itemsAdd, setItemsAdd] = useState([]);
  const [showNewForm, setShowNewForm] = useState(false);
  const [deleteLastItem, setDeleteLastItem] = useState(false);
  const [masterPrice, setMasterPrice] = useState(item?.masterPrice)
  const {
    description,
    application,
    brand,
    price,
    partNumber,
    uom,
    idStations,
    inventoriable,
    idCategory,
    idClass,
  } = inputValues;

  const handleChangeStation = event => {
    handleNewValues({
      ...inputValues,
      idStations: event,
    });
    setItemsAdd(Object.keys(itemsAdd).length > 0 ? Object.keys(itemsAdd).map(key => {
      if (key === "0") {
        itemsAdd[0] = { ...inputValues, idStations: event }
      }
      return itemsAdd[key]
    }) : [{ ...inputValues, idStations: event }])
    setSelectedCompanies(event);
  }

  const handleInputChange = (e) => {
    handleInputOnChange(e)
    setItemsAdd(Object.keys(itemsAdd).length > 0 ? Object.keys(itemsAdd).map(key => {
      if (key === "0") {
        itemsAdd[0] = { ...inputValues, [e.target.name]: e.target.value }
      }
      return itemsAdd[key]
    }) : [inputValues])
  }

  const handleCloseSnackbar = () => {
    dispatch(resetItemSnackbar());
  };

  const handleAddItems = (newItem) => {
    setItemsAdd([...itemsAdd, newItem])
  }

  const handleChange = () => {
    const form = {
      itemId: "",
      itemNumber: "",
      description: "",
      application: "",
      brand: "",
      price: "",
      partNumber: "",
      uom: "",
      idStations: [],
      inventoriable: "1",
      idCategory: '',
      idClass: '',
    };
    handleAddItems(form)
  }

  const handleDeleteToSave = () => {
    if (itemsAdd[1]) {
      setSelectedCompanies(itemsAdd[1]?.idStations)
      handleNewValues(itemsAdd[1]);
      setDeleteLastItem(true)
    }
    else {
      onClose()
    }
    if (modalEdit) {
      dispatch(removeItemToUpdate(inputValues.itemNumber))
      setTimeout(() => {
        setItemsAdd(Object.values(itemsAdd).filter(value => value.itemNumber !== inputValues.itemNumber))
      }, 500);
    }
    else {
      setTimeout(() => {
        setItemsAdd(Object.values(itemsAdd).filter(value => value?.description !== inputValues?.description))
      }, 500);
    }


  }

  const handleDeleteItem = () => {
    setShowNewForm(false)
  }


  const handleNewForm = () => {
    const error = runValidates();
    if (error) return;
    if (Object.keys(idStations).length === 0) {
      dispatch(setItemSnackbar("No hay plantas seleccionadas"))
      return;
    }
    handleChange()
    setShowNewForm(true);
  }

  const handleSaveItemUpdate = () => {
    if (Object.keys(itemsAdd).length > 0) {
      dispatch(setItemSnackbar("Se guardo lista de artículos sin crear petición", "success"))
      dispatch(saveItemsToUpdate(itemsAdd))
      dispatch(saveOriginalItemToUpdate(item))
      onClose()
    } else {
      dispatch(setItemSnackbar("No se detectaron cambios"))
    }
  }

  const handleSubmit = () => {
    const error = runValidates();
    if (error) return;
    if (Object.keys(idStations).length === 0) {
      dispatch(setItemSnackbar("No hay plantas seleccionadas"))
      return;
    }
    if (modalEdit) {
      if (Object.keys(itemsAdd).length > 0) {
        const editForm = Object.values(itemsAdd).map(itemEdit => {
          return {
            description: itemEdit.description.slice(0, 67) + (itemEdit.description.length > 67 ? "..." : ""),
            itemId: itemEdit.itemId,
            itemNumber: itemEdit.itemNumber,
            price: parseFloat(itemEdit.price),
            stations: Object.values(itemEdit.idStations).map(e => {
              return e?.oraclePrice ?
                { id: e.value, oraclePrice: e?.oraclePrice } :
                { id: e.value, oraclePrice: masterPrice }
            }),
          }
        })
        const request = {
          type: 'UPDATE',
          idUser: idUser,
          items: editForm,
        }
        dispatch(itemsRequests(request));
        onClose()
      }
      else {
        dispatch(setItemSnackbar("No se detectaron cambios"))
      }
    }
    else {
      const createForm = Object.values(itemsAdd).map(itemCreate => {
        return {
          description: itemCreate.description.toUpperCase(),
          application: itemCreate.application.toUpperCase(),
          brand: itemCreate.brand.toUpperCase(),
          price: parseFloat(itemCreate.price),
          partNumber: itemCreate.partNumber,
          uom: itemCreate.uom,
          stations: Object.values(itemCreate.idStations).map((station) => station.value),
          inventoriable: parseInt(itemCreate.inventoriable),
          idCategory: itemCreate.idCategory,
          idClass: itemCreate.idClass,
        }
      })
      const request = {
        type: 'CREATE',
        idUser: idUser,
        items: createForm,
      }
      dispatch(itemsRequests(request));
      onClose()
    }
  };

  const itemNumbers = [
    {
      value: 'PZA',
      label: 'Pieza'
    },
    {
      value: 'LTR',
      label: 'Litros'
    },
    {
      value: 'KGM',
      label: 'Kilogramos'
    },
    {
      value: 'MTR',
      label: 'Metros'
    }
  ];

  const isInventariable = [
    {
      value: "1",
      label: "Si"
    },
    {
      value: "0",
      label: "No"
    }
  ]

  const mapCategories = Object.keys(categories).map((key) => {
    return {
      value: categories[key].id,
      label: categories[key].name
    }
  })

  const mapClasses = Object.keys(allClasses).map((key) => {
    return ({
      value: allClasses[key].id,
      label: allClasses[key].name
    })
  })

  useEffect(() => {
    let time = setTimeout(() => {
      if (modalEdit && Object.keys(item).length > 0 && Object.keys(updateItems).length === 0) {
        const newValues = {
          itemId: item?.itemId,
          itemNumber: item?.itemNumber,
          description: item?.itemDescription,
          price: idStation && Object.keys(idStation).length > 0 ? item?.organizations[idStation.value]?.listPrice : item?.masterPrice,
          idStations: idStation ? [idStation] : [],
        };
        if (idStation) {
          setSelectedCompanies([idStation])
        }
        handleNewValues(newValues);
      }
      if (modalEdit && Object.keys(item).length > 0 && Object.keys(updateItems).length > 0) {
        Object.keys(updateItems).map(key => {
          if (key === "0") {
            const firstItemEdit = {
              itemId: updateItems[key]?.itemId,
              itemNumber: updateItems[key]?.itemNumber,
              description: updateItems[key]?.description,
              price: updateItems[key]?.price,
              idStations: item?.itemId === updateItems[key]?.itemId && idStation
                ? [...updateItems[key]?.idStations, idStation]
                : updateItems[key]?.idStations
            };
            setSelectedCompanies(item?.itemId === updateItems[key]?.itemId && idStation
              ? [...updateItems[key]?.idStations, idStation]
              : updateItems[key]?.idStations
            );
            setMasterPrice(originalItems[0]?.masterPrice)
            setStationValues(stationsList.map(station => {
              return originalItems[0]?.organizations && Object.keys(originalItems[0]?.organizations).find(key => key === station?.id) ?
                { value: station.id, label: station.name, oraclePrice: originalItems[0]?.organizations[station.id]?.listPrice } :
                { value: station.id, label: station.name };
            }))
            handleNewValues(firstItemEdit);
          }
        })
        if (Object.values(updateItems).filter(e => e.itemId === item?.itemId).length > 0) {
          setItemsAdd(idStation ? Object.values(updateItems).map(value => {
            if (item?.itemId === value?.itemId) {
              return ({ ...value, idStations: [...value.idStations, idStation] })
            }
            return value;
          }) : updateItems)
          updateItems[0]?.itemId !== item?.itemId && setShowNewForm(true);
        } else {
          const newValues = {
            itemId: item?.itemId,
            itemNumber: item?.itemNumber,
            description: item?.itemDescription,
            price: idStation && Object.keys(idStation).length > 0 ? item?.organizations[idStation.value]?.listPrice : item?.masterPrice,
            idStations: idStation ? [idStation] : [],
          };
          setItemsAdd([...updateItems, newValues])
          setShowNewForm(true);
        }
      }
      else if (modalEdit && Object.keys(updateItems).length > 0) {
        Object.keys(updateItems).map(key => {
          if (key === "0") {
            const firstItemEdit = {
              itemId: updateItems[key]?.itemId,
              itemNumber: updateItems[key]?.itemNumber,
              description: updateItems[key]?.description,
              price: updateItems[key]?.price,
              idStations: item?.itemId === updateItems[key]?.itemId && idStation
                ? [...updateItems[key]?.idStations, idStation]
                : updateItems[key]?.idStations
            };
            setSelectedCompanies(item?.itemId === updateItems[key]?.itemId && idStation
              ? [...updateItems[key]?.idStations, idStation]
              : updateItems[key]?.idStations
            );
            setMasterPrice(originalItems[0]?.masterPrice)
            setStationValues(stationsList.map(station => {
              return originalItems[0]?.organizations && Object.keys(originalItems[0]?.organizations).find(key => key === station?.id) ?
                { value: station.id, label: station.name, oraclePrice: originalItems[0]?.organizations[station.id]?.listPrice } :
                { value: station.id, label: station.name };
            }))
            handleNewValues(firstItemEdit);
          }
        })
        setItemsAdd(updateItems)
        if (Object.values(updateItems).length > 1) {
          setShowNewForm(true);
        }
      }
    }, 500);
    return () => { clearTimeout(time); }
  }, [item, modalEdit]);

  useEffect(() => {
    newItemMode && cleanForm();
  }, [newItemMode]);

  return (
    <FormControl fullWidth className={animations.fadeIn}>
      <Grid container spacing={1} classes={{
        root: {
          ref: ref
        }
      }}>

        <Grid container justifyContent="flex-end">
          <RegularButton
            color="transparent"
            round
            justIcon
            onClick={handleDeleteToSave}
            tooltip="Eliminar"
            style={{
              bottom: 10,
              right: 10,
            }}
          >
            <CancelIcon style={{ color: "#f6685e" }} />
          </RegularButton>
        </Grid>

        <Grid item xs={12}>
          <TextField
            fullWidth
            label="Descripción"
            name="description"
            value={description}
            onChange={handleInputChange}
            variant="outlined"
            autoFocus={true}
            error={fieldErrors.description}
            helperText={fieldErrors.description || ""}
            disabled={modalEdit ? true : false}
          />
        </Grid>
        {!modalEdit ?
          <>
            <Grid item xs={12} sm={12}>
              <TextField
                fullWidth
                label="Aplicación"
                name="application"
                value={application}
                onChange={handleInputChange}
                variant="outlined"
                error={fieldErrors.application}
                helperText={fieldErrors.application || ""}
              />
            </Grid>
            <Grid item xs={12} sm={12}>
              <Grid container spacing={1}>
                <Grid item xs={12} sm={4}>
                  <TextField
                    fullWidth
                    label="Marca"
                    name="brand"
                    value={brand}
                    onChange={handleInputChange}
                    variant="outlined"
                    error={!!fieldErrors.brand}
                    helperText={fieldErrors.brand}
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <TextField
                    fullWidth
                    label="Precio unitario"
                    name="price"
                    value={price}
                    onChange={handleInputChange}
                    variant="outlined"
                    error={!!fieldErrors.price}
                    helperText={fieldErrors.price}
                    InputProps={{
                      startAdornment: <InputAdornment position="start">$</InputAdornment>
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <TextField
                    fullWidth
                    label="Número de parte"
                    name="partNumber"
                    value={partNumber}
                    onChange={handleInputChange}
                    variant="outlined"
                    error={!!fieldErrors.partNumber}
                    helperText={fieldErrors.partNumber}
                  />
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={6}>
              <SelectComponent
                label="Unidad de medida"
                name="uom"
                value={uom}
                onChange={handleInputChange}
                options={itemNumbers}
                defaultValue="Unidad de medida"
                error={fieldErrors.uom}
                helperText={fieldErrors.uom || ""}
              />
            </Grid>
            <Grid item xs={6}>
              <SelectComponent
                label="Inventariable"
                name="inventoriable"
                value={inventoriable}
                onChange={handleInputChange}
                options={isInventariable}
                defaultValue="Inventariable"
                error={fieldErrors.inventoriable}
                helperText={fieldErrors.inventoriable || ""}
              />
            </Grid>
            <Grid item xs={6}>
              <SelectComponent
                label="Categoría"
                name="idCategory"
                value={idCategory}
                onChange={handleInputChange}
                options={mapCategories}
                defaultValue="Categoría"
                error={fieldErrors.idCategory}
                helperText={fieldErrors.idCategory || ""}
              />
            </Grid>
            <Grid item xs={6}>
              <SelectComponent
                label="Clase"
                name="idClass"
                value={idClass}
                onChange={handleInputChange}
                options={mapClasses}
                defaultValue="Clase"
                error={fieldErrors.idClass}
                helperText={fieldErrors.idClass || ""}
              />
            </Grid>
          </>
          : <Grid item xs={12} sm={4}>
            <TextField
              fullWidth
              label="Precio unitario"
              name="price"
              value={price}
              onChange={handleInputChange}
              variant="outlined"
              error={!!fieldErrors.price}
              helperText={fieldErrors.price}
              InputProps={{
                startAdornment: <InputAdornment position="start">$</InputAdornment>
              }}
            />
          </Grid>
        }

        <Grid item xs={12}>
          <FormLabel
            style={{ backgroundColor: 'white', padding: '5px 10px', borderRadius: 4, }}
          >
            Plantas
          </FormLabel>
          <MultiSelect
            placeholder="Plantas.."
            name="selectedCompanies"
            value={selectedCompanies}
            components={animatedComponents}
            options={stationsValues}
            onChange={handleChangeStation}
            className="list-select__container "
            classNamePrefix="select"
            allLabel="Todas las plantas"
          />
        </Grid>
        {!showNewForm &&
          <Grid item xs={12}
            style={{ display: "flex", justifyContent: "flex-end", gap: 8 }}
          >
            {newItemMode &&
              <RegularButton color="info" onClick={handleNewForm}>
                Agregar otro Artículo
              </RegularButton>
            }
            {
              modalEdit &&
              <RegularButton color="info" onClick={handleSaveItemUpdate}>
                Guardar sin solicitud
              </RegularButton>
            }
            <RegularButton color="success" onClick={handleSubmit}>
              {newItemMode ? `Alta de Artículo` : "Actualizar Producto"}
            </RegularButton>
          </Grid>
        }
      </Grid>
      {
        showNewForm &&
        <NewItemForm
          onClose={onClose}
          initialValues={initialValues}
          fieldValidations={fieldValidations}
          itemNumbers={itemNumbers}
          handleCloseSnackbar={handleCloseSnackbar}
          idUser={idUser}
          itemsAdd={itemsAdd}
          setItemsAdd={setItemsAdd}
          count={1}
          modalEdit={modalEdit}
          handleSaveItemUpdate={handleSaveItemUpdate}
          handleChange={handleChange}
          isInventariable={isInventariable}
          mapCategories={mapCategories}
          mapClasses={mapClasses}
          handleDeleteItem={handleDeleteItem}
          deleteLastItem={deleteLastItem}
          setDeleteLastItem={setDeleteLastItem}
        />
      }
      <Snackbar
        place="tr"
        open={isOpen}
        color={color}
        message={message}
        close
        closeNotification={handleCloseSnackbar}
      />
    </FormControl>
  );
};
